import React, { Children } from "react";
import { useRecoilState } from "recoil";
import { getCertificateCreateFormAtom } from "raft/CertificateForm";
import Props from "./index.d";
import { StyledGridFormingUnitRowForSwitchingOperationCheckbox } from "./styles";

interface GFCFieldSet_GridFormingSwitchOperationCheckboxWrapperExtended extends Props {
  children: React.ReactNode;
}
/**
 * Grid Forming version - Only renders children if category is ASYNCHRONOUS_GENERATOR or SYNCHRONOUS_GENERATOR
 * and normList includes 10, 20, or 30. Otherwise returns null.
 */
const GridFormingSwitchOperationCheckboxWrapper: React.FC<
  GFCFieldSet_GridFormingSwitchOperationCheckboxWrapperExtended
> = ({ children, className }) => {
  const childrenCount = Children.count(children);
  const createUnitAtom = getCertificateCreateFormAtom({ formVersion: "matrixCertificateCreate" });
  const [certificateValues] = useRecoilState(createUnitAtom);
  const category = certificateValues?.category;
  const normList = certificateValues?.__normList;

  const isGen = category === "ASYNCHRONOUS_GENERATOR" || category === "SYNCHRONOUS_GENERATOR";
  const normOk = typeof normList === "string" && ["10", "20", "30"].some((n) => normList.includes(n));

  if (!isGen || !normOk || !category) {
    return null;
  }

  return (
    <StyledGridFormingUnitRowForSwitchingOperationCheckbox isSingle={childrenCount === 1} className={className}>
      {children}
    </StyledGridFormingUnitRowForSwitchingOperationCheckbox>
  );
};

export default GridFormingSwitchOperationCheckboxWrapper;
